/**
 * 营销活动类型
 */

export enum TMarketingCate {
  // 单品活动
  Single = 'singleItemDiscount', // 单品折扣
  NthItemNDiscount = 'nthItemNDiscount', // 第二份半价
  DesignatedItemDiscount = 'designatedItemDiscount', // 指定单品满减
  FullItemNFree = 'fullItemNFree', // 单品满送
  LadderDiscount = 'ladderDiscount', // 多商品阶梯
  SingleItemSwapBuy = 'singleItemSwapBuy', // 单品换购
  SpecialOffer = 'specialOffer', // 特价商品
  OrderSwapBuy = 'orderSwapBuy', // 指定餐品换购
  ExpressFeeDiscount = 'expressFeeDiscount', // 配送费减免活动
  ConsumeRebate = 'consumeRebate', // 消费返现
  GroupBuy = 'groupBuy', // 拼团活动
  // 整单活动
  Order = 'orderDiscount', // 订单折扣
  // 券活动
  DeliveryCoupon = 'deliveryCoupon', // 扫码赠券
  BirthdayCoupon = 'birthdayCoupon', // 生日赠券
  CollectPoint = 'collectPoint', // 集点赠券
  WechatCoupon = 'concernWechatOfficialSendCoupon', // 关注公众号送券
  MobileCoupon = 'bindMobileSendCoupon', // 绑定手机号送券
  PrizeCoupon = 'prizeCoupon', // 抽奖得券,
  InvitationCoupon = 'invitationCoupon', // 邀请好友得券
  ConsumeCoupon = 'consumeSendCoupon', // 消费送券
  PromoCodeSendCoupon = 'promoCodeSendCoupon' // 优惠码送券
}

/** 单个营销计算器返回的类型 */
export enum TCalActivityType {
  Express = 'express'
}

/** 团购券类型 */
export enum TGroupByProductType {
  coupons = 'coupons',
  randomBox = 'randomBox',
  luckyBag = 'luckyBag',
}
